// Source/Inspiration: https://stackoverflow.com/a/59809700/16940103

// from @peduarte at https://gist.github.com/peduarte/969217eac456538789e8fac8f45143b4
function throttle(func) {
    // throttle scroll by this much (ms)
    let scroll_throttle = 200;
    let timer = null;
    return function (...args) {
        if (timer === null) {
            timer = setTimeout(() => {
                func.apply(this, args);
                timer = null;
            }, scroll_throttle);
        }
    };
}

// Check if current browser is Safari (source: https://www.browserstack.com/guide/create-browser-specific-css)
function isSafari() {
    return (
        (!!window.ApplePaySetupFeature || !!window.safari) &&
        agentHas("Safari") &&
        !agentHas("Chrome") &&
        !agentHas("CriOS")
    );
}

// Disable Scroll Menu on Safari because its buggy (and I have no means of developing/testing it)
if(isSafari()) {
    let scrollmenus = document.getElementsByClassName("scrollmenu")
    for (let i = 0; i < scrollmenus.length; i++) {
        const s = scrollmenus[i];
        s.style.display = "none"
    }
}

// Get all Anchors
let anchors = document.getElementsByClassName("section-anchor");

// reserve this so we can overwrite it later
let reachedTop;

let currentSection = -1;
const checkOffsets = () => {
    for (let i = anchors.length - 1; i >= 0; i--) {
        let anchor = anchors[i];

        // This is used to ignore the hidden Service Tables.
        // This function therefore performs the highlighting only on the present anchors.
        if (anchor.offsetTop == 0) {
            continue;
        }

        // Tolerance is used since its slightly buggy otherwise (a rounding error by the scrollY)
        let tolerance = 10;
        let targetOffset = anchor.offsetTop - tolerance;
        if (scrollY >= targetOffset) {
            if (currentSection == i) {
                break;
            }
            currentSection = i;
            activateNavBtn(i);
            break;
        }
    }
};

// Attach class to active section
const activateNavBtn = (clickedIndex) => {
    // Remove active class from all
    navbarBTNs.forEach((btn) => {
        btn.classList.remove("scrollmenu-active");
    });

    // Add active class to the relevant button
    navbarBTNs[clickedIndex].classList.add("scrollmenu-active");

    navbarBTNs[clickedIndex].scrollIntoView({ inline: "start" });
};

/**
 * Get Navbar BTNs and attach onClick function to them. The reason for
 * getting them in such a weird way is, that we don't know the IDs at runtime
 * since those are generated out of a JSON which can change.
 */
let navbarBTNs = [];
for (let i = 0; i < anchors.length; i++) {
    let id = anchors[i].getAttribute("id");
    let navbarBtn = document.querySelector(`[href="#${id}"]`);
    navbarBTNs.push(navbarBtn);
}

// throttle our function
const throttledScroll = throttle(checkOffsets);
document.addEventListener("scroll", throttledScroll);
// Run once on init
checkOffsets();
